/* eslint jsx-a11y/alt-text: 0 */
import React from "react"
import styled from "styled-components"
import {Flex} from "./Flex"

const LegendItem = (props) => {
  return (
    <OuterDiv>
      <SquareDiv color={props.color} />
      <Flex alignItems="flex-start">
        <LabelDiv>{props.label}</LabelDiv>
        {props.value && (
          <div>
            <strong>{props.value}</strong>
          </div>
        )}
      </Flex>
    </OuterDiv>
  )
}

const OuterDiv = styled.div`
  line-height: 1;
  padding-left: ${(props) =>
    props.theme.fontSizeSmall + props.theme.gutter / 4}px;
  position: relative;
`

const LabelDiv = styled.div`
  flex-grow: 1;
  padding-right: ${(props) => props.theme.gutter}px;
`

const SquareDiv = styled.div`
  background-color: ${(props) => props.color};
  border-radius: 2px;
  height: ${(props) => props.theme.fontSizeSmall * 0.9}px;
  left: 0;
  position: absolute;
  top: ${(props) => props.theme.fontSizeSmall * 0.05}px;
  width: ${(props) => props.theme.fontSizeSmall * 0.9}px;
`

LegendItem.defaultProps = {
  color: "#ddd",
  items: [],
}

export {LegendItem}
